<template>
  <q-page class="flex flex-center">
    <div class="text-center q-pa-xl" style="max-width: 480px">
      <q-icon name="construction" size="64px" color="grey-5" />
      <div class="text-h6 q-mt-md text-grey-8">{{ titulo }}</div>
      <div class="text-body2 q-mt-sm text-grey-6">
        Esta tela ainda não está disponível.
      </div>
      <q-btn
        flat
        color="primary"
        class="q-mt-lg"
        label="Voltar ao início"
        @click="$router.push('/')"
      />
    </div>
  </q-page>
</template>

<script>
/**
 * Tela ainda não implementada.
 *
 * Cinco rotas de `src/router/router.js` apontavam para arquivos `.vue` de ZERO bytes,
 * assim desde 2019 (commit 2129a795): `/empresa`, `/notificacao` (hoje a tela de notificações), `/fluxo_de_caixa`,
 * `/plano_contratado` e `/suporte`. Nenhuma tem link em menu nenhum — só se chega
 * digitando a URL — e o que aparecia era uma página em branco, sem explicação.
 *
 * O webpack 4 aceita um SFC vazio e renderiza nada em silêncio. O Vite recusa, com
 * "At least one <template> or <script> is required": foi a migração que tornou as
 * cinco visíveis.
 *
 * Isto NÃO decide o destino delas. Apagar as rotas ou implementar as telas é decisão
 * de produto, e continua aberta. O que muda aqui é que a tela passa a dizer o que
 * está acontecendo, em vez de não dizer nada.
 */
export default {
  name: 'TelaIndisponivel',
  props: {
    titulo: { type: String, default: 'Tela em construção' },
  },
};
</script>
